import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { TYPE_GLOBAL_PROPOTIES, TYPE_GLOBAL_PROPOTIES_CANCEL_REASON } from "app/common/LocalConst";
import { saveOrUpdateGlobalProperty } from "app/services/GlobalPropertyService";
import { toast } from "react-toastify";

export default class ReasonCancelStore {
  searchReasonCancel = new SearchObject();
  pageReasonCancel = null;
  selectedReasonCancel = { dataType: TYPE_GLOBAL_PROPOTIES_CANCEL_REASON };
  openFormCreateOrEditReasonCancel = false;
  openConfirmDeleteReasonCancel = false;

  constructor() {
    makeAutoObservable(this);
  }

  handleOpenFormCreateOrEditReasonCancel = () => {
    this.selectedReasonCancel = {}
    this.openFormCreateOrEditReasonCancel = true
  };
  handleClosePopupReasonCancel = () => {
    this.openFormCreateOrEditReasonCancel = false
  }
  saveReasonCancel = (conceptAttributeType, { setSubmitting }) => {
    return saveOrUpdateGlobalProperty(conceptAttributeType)
      .then(({ data }) => {
        this.selectedReasonCancel = null;
        toast.success("Lưu thành công!");
        this.handleClosePopupReasonCancel();
        return data;
      })
      .finally(() => setSubmitting(false));
  };
  resetStore = () => {
    this.searchRevenueExpenditure = new SearchObject();
    this.pageRevenueExpenditure = null;
    this.selectedReasonCancel = { entryType: TYPE_GLOBAL_PROPOTIES_CANCEL_REASON };
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteRevenueExpenditure = false;
  };
}
